import { components } from './components';
import { nearbyUnits } from './nearbyUnits';
import { searchUnits } from './searchUnits';
import { unitDetails } from './unitDetails';

const es = { ...components, ...nearbyUnits, ...searchUnits, ...unitDetails };

export default es;
